import React, { memo } from 'react';
import { useObservable } from 'react-use-observable';

import { FilterOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';

import { Field, useFormikContext } from 'formik';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { SelectProduct } from 'v2/components/Shared/FormFields/SelectProduct';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import type { IFilter } from 'v2/interfaces/affiliate';
import affiliateService, { getInitialFilter } from 'v2/services/affiliate';

const Basic = () => {
  const [isLoading] = useObservable(() => affiliateService.isLoading(), []);

  const { values, setFieldValue, isSubmitting, isValid, setErrors, dirty, resetForm } = useFormikContext<IFilter>();

  const onChangeAffiliateType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue('affiliate_type', e.target.value);
    setFieldValue('affiliate_value', '');
    setErrors({});
  };

  const handleClearFilter = () => {
    const clearedValues = getInitialFilter();
    resetForm({ values: clearedValues });
    affiliateService.cleanFilter();
  };

  const AffiliatesTypeOptions = [
    { label: 'Nome', value: 'affiliate_name' },
    { label: 'E-mail', value: 'affiliate_email' }
  ];

  const StatusOptions = [
    { label: 'Pendente', value: 'pending' },
    { label: 'Aprovado', value: 'approved' },
    { label: 'Reprovado', value: 'reproved' }
  ];

  return (
    <div className='w-full rounded-sm bg-white p-2'>
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={12} md={8}>
          <Field
            isPresetLonger
            label='Data da solicitação'
            id='date'
            name='date'
            component={DateRangePickerFormField}
          />
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Field
            id='affiliate_type'
            name='affiliate_type'
            label='Afiliado'
            fullWidth
            options={AffiliatesTypeOptions}
            component={SelectFormField}
            onChange={onChangeAffiliateType}
          />
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Field
            id='affiliate_value'
            name='affiliate_value'
            type={values.affiliate_type === 'affiliate_email' ? 'email' : 'text'}
            label={values.affiliate_type === 'affiliate_email' ? 'E-mail' : 'Nome'}
            placeholder={values.affiliate_type === 'affiliate_email' ? 'Digite o e-mail' : 'Digite o nome'}
            component={TextFormField}
            fullWidth
          />
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Field
            id='product_id'
            name='product_id'
            fullWidth
            label='Produtos'
            endpoint='/affiliates/filter/products'
            component={SelectProduct}
          />
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Field
            id='status'
            name='status'
            label='Status'
            fullWidth
            options={StatusOptions}
            component={SelectFormField}
          />
        </Col>
        <Col xs={12} md={4} className='flex items-end pt-6'>
          <Button
            id='clear-button'
            loading={isLoading || isSubmitting}
            disabled={!dirty || isSubmitting || isLoading}
            block
            onClick={handleClearFilter}
          >
            Limpar
          </Button>
        </Col>
        <Col xs={12} md={4} className='flex items-end'>
          <div className='mt-6 flex w-full justify-end'>
            <Button
              type='primary'
              icon={<FilterOutlined />}
              disabled={!isValid || isSubmitting || isLoading}
              block
              htmlType='submit'
            >
              Filtrar
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default memo(Basic);
